import * as actionTypes from '@store/actions/actionTypes'

const reducer = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_TYPEAHEAD_QUERY:
      return {
        ...state,
        [action.key]: { ...state[action.key], query: action.query }
      }

    case actionTypes.SET_TYPEAHEAD_SUGGESTIONS:
      return {
        ...state,
        [action.key]: { ...state[action.key], suggestions: action.suggestions }
      }

    case actionTypes.SET_TYPEAHEAD_SELECTED_ITEM:
      return {
        ...state,
        [action.key]: { ...state[action.key], selected: action.obj }
      }

    case actionTypes.REMOVE_TYPEAHEAD_KEY:
      /* eslint-disable no-case-declarations */
      const { [action.key]: removed, ...updated } = state
      return { ...updated }

    default:
      return state
  }
}

export default reducer
